import { gql } from '@apollo/client';

export const ADD_UPDATE_FINANCIAL_PRODUCT = gql`
  mutation addOrUpdateFinancialProduct($input: FinancialProductItemInput) {
    addOrUpdateFinancialProduct(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_FINANCIAL_PRODUCT_STATE = gql`
  mutation updateFinancialProductState($financialProductId: Int!, $newStateId: Int!, $newStateName: String, $flowId: Int!, $userId: Int!, $activeProduct: Boolean!) {
    updateFinancialProductState(
      financialProductId: $financialProductId
      newStateId: $newStateId
      newStateName: $newStateName
      flowId: $flowId
      userId: $userId,
      activeProduct: $activeProduct
    ) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_RULE = gql`
  mutation deleteFinancialProductRule($input: DeleteFinancialProductRuleInput) {
    deleteFinancialProductRule(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_WARRANTY = gql`
  mutation deleteFinancialProductWarranty($input: DeleteFinancialProductWarrantyInput) {
    deleteFinancialProductWarranty(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_FINANCIAL_PRODUCT_PROPERTY = gql`
  mutation addOrUpdateFinancialProductProperty($input: FinancialProductPropertyInput) {
    addOrUpdateFinancialProductProperty(input: $input) {
      commandId
      correlationId
    }
  }
`;
export const ADD_UPDATE_FINANCIAL_PRODUCT_INSURER = gql`
  mutation addOrUpdateFinancialProductInsurer($input: FinancialProductInsurerItemInput) {
    addOrUpdateFinancialProductInsurer(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_INSURER = gql`
  mutation deleteFinancialProductInsurer($input: DeleteFinancialProductInsurerItemInput) {
    deleteFinancialProductInsurer(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_PROPERTY = gql`
  mutation deleteFinancialProductProperty($input: DeleteFinancialProductPropertyItemInput) {
    deleteFinancialProductProperty(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_RESIDUAL_GRID = gql`
  mutation deleteFinancialProductResidualGrid($input: DeleteFinancialProductResidualGridItemInput) {
    deleteFinancialProductResidualGrid(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_FINANCIAL_PRODUCT_RESIDUAL_GRID = gql`
  mutation addOrUpdateFinancialProductResidualGrid($input: FinancialProductResidualGridInput) {
    addOrUpdateFinancialProductResidualGrid(input: $input) {
      commandId
      correlationId
    }
  }
`;
